import { Box, createStyles } from '@mantine/core';
import type { ReactNode } from 'react';
import { memo } from 'react';

const useStyles = createStyles((theme) => ({
	wrapper: {
		padding: `${theme.spacing.sm} ${theme.spacing.sm} ${theme.spacing.sm} ${theme.spacing.md}`,
		borderRadius: theme.radius.md,
		boxShadow: theme.shadows.sm,
		backgroundColor: theme.other.getColor('surface/primary/default'),
		width: '100%',
	},
}));

export const AiChatEmbedPreviewBody = memo(
	({ children }: { children: ReactNode }) => {
		const { classes } = useStyles();

		return <Box className={classes.wrapper}>{children}</Box>;
	}
);
